import { Alert } from "@mui/material";

import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import Body from "../../components/theme/Body";
import Button from "../../components/theme/Button";
import Heading from "../../components/theme/Heading";
import useFetch from "../../hooks/useFetch";

const Delete = () => {
  const [fetch, { error, loading, submitted }] = useFetch(
    window.location.href.replace("/delete", ""),
    {
      method: "DELETE",
    },
  );

  if (submitted) {
    return (
      <>
        <MetaData title="Verzoek intrekken" />
        <Main>
          <Body marginBottom="1em" maxWidth={800}>
            Het verzoek is ingetrokken
          </Body>
        </Main>
      </>
    );
  }

  return (
    <>
      <MetaData title="Verzoek intrekken" />
      <Main>
        <Heading marginBottom="0.5em" variant="h1">
          Verzoek intrekken
        </Heading>
        <Body marginBottom="1em" maxWidth={800}>
          Heb je de reiskostenvergoeding toch niet nodig? Trek het verzoek in
          zodat sponsoren een andere demonstrant kunnen helpen.
        </Body>
        <Button loading={loading} variant="contained" onClick={() => fetch()}>
          Verzoek intrekken
        </Button>
        {error && (
          <Alert severity="error" sx={{ marginTop: "1em" }}>
            {error}
          </Alert>
        )}
      </Main>
    </>
  );
};

export default Delete;
